
export const SpeechRecognition = (window['SpeechRecognition'] || window['webkitSpeechRecognition'] || window['mozSpeechRecognition'] || window['msSpeechRecognition'])


// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/voice-control/speech-recognition.api.ts